var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CouponDetail'),(_vm.infoStatus==10)?_c('div',{staticClass:"operation"},[_c('van-button',{staticStyle:{"width":"100%"},attrs:{"type":"primary","size":"normal"},on:{"click":_vm.injection}},[_vm._v("去投放")])],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }